import { memo, useCallback, type CSSProperties } from 'react';

import XMarkIcon from '@heroicons/react/24/outline/XMarkIcon';
import { Icon } from 'atp-react-ui';
import type { ClearIndicatorProps } from 'react-select';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ClearIndicator = memo((props: ClearIndicatorProps<any, true>) => {
  const {
    children = <Icon icon={XMarkIcon} className="size-3.5 text-gray-500" />,
    getStyles,
    innerProps: { ref, onMouseDown, onTouchEnd, ...restInnerProps },
    clearValue,
  } = props;

  const handleMouseDown = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      clearValue();
      if (this === e.target && onMouseDown) {
        onMouseDown(e);
      }
      e.stopPropagation();
    },
    [clearValue, onMouseDown]
  );

  const handleTouchEnd = useCallback(
    (e: React.TouchEvent<HTMLDivElement>) => {
      clearValue();
      if (this === e.target && onTouchEnd) {
        onTouchEnd(e);
      }

      e.stopPropagation();
    },
    [clearValue, onTouchEnd]
  );

  return (
    <div
      {...restInnerProps}
      onMouseDown={handleMouseDown}
      onTouchEnd={handleTouchEnd}
      ref={ref}
      style={getStyles('clearIndicator', props) as CSSProperties}
      className="p-0! px-1! w-5 cursor-pointer"
    >
      {children}
    </div>
  );
});
